import { gql } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import type {
  ReactionAvatarStack_ReactionFragment,
  ReactionThreadMinimized_ThreadFragment,
} from '../../graphql/generated/graphqlTypes';
import ReactionAvatarStack from './ReactionAvatarStack';

const THREAD_FRAGMENT = gql`
  fragment ReactionThreadMinimized_thread on PublicThreadFields {
    id
    reactions {
      id
      ...ReactionAvatarStack_reaction
    }
  }
  ${ReactionAvatarStack.fragments.reaction}
`;

interface ReactionThreadMinimizedProps {
  thread: ReactionThreadMinimized_ThreadFragment;
}

const ReactionThreadMinimized = ({ thread }: ReactionThreadMinimizedProps) => {
  // TODO: remove `threadReactions` when we upgrade to TypeScript 5.2
  const threadReactions: ReactionAvatarStack_ReactionFragment[] =
    thread.reactions;
  const firstReaction = _.first(threadReactions);

  return firstReaction ? (
    <ReactionAvatarStack reactions={[firstReaction]} ring={false} />
  ) : null;
};

ReactionThreadMinimized.fragments = { thread: THREAD_FRAGMENT };

export default ReactionThreadMinimized;
